module.exports = __webpack_public_path__ + "static/office-8f415a6a96e99d34b1a7b16930651b21.jpeg";